import React from 'react'
import classNames from 'classnames'
import Button from 'components/common/Button'
import './CTABlock.scss'

const CTABlock = ({ block }) => {
  // Convert newlines to <br /> tags
  const renderContentWithBreaks = (content) => {
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < content.split('\n').length - 1 && <br />}
      </React.Fragment>
    ))
  }

  const renderLink = (link, index) => {
    // If LinkType is "Button", render as Button component
    if (link.LinkType === 'Button') {
      return (
        <a
          key={link.Id || index}
          href={link.Url}
          className="cta-button-wrapper"
          target={link.IsExternal ? '_blank' : '_self'}
          rel={link.IsExternal ? 'noopener noreferrer' : undefined}
        >
          <Button
            type="button"
            text={link.LinkText}
            className="cta-button"
          />
        </a>
      )
    }

    // Otherwise render as regular link
    return (
      <a
        key={link.Id || index}
        href={link.Url}
        className={classNames('cta-link', {
          'external': link.IsExternal
        })}
        target={link.IsExternal ? '_blank' : '_self'}
        rel={link.IsExternal ? 'noopener noreferrer' : undefined}
      >
        {link.LinkText}
      </a>
    )
  }

  return (
    <div
      className="block block-cta"
      style={block.ImageUrl ? { backgroundImage: `url(${block.ImageUrl})` } : {}}
    >
      <div className="cta-content">
        {block.Heading && <h2>{block.Heading}</h2>}
        {block.Content && (
          <div>{renderContentWithBreaks(block.Content)}</div>
        )}
        {block.Links && block.Links.length > 0 && (
          <div className="cta-links">
            {block.Links.map((link, index) => renderLink(link, index))}
          </div>
        )}
      </div>
    </div>
  )
}

export default CTABlock
